const VerticalLayout = () => import('@/layouts/VerticalLayout')

const instructors = () => import('./views/index')

const current = () => import('./views/current.vue')
const requests = () => import('./views/requests.vue')
const history = () => import('./views/history.vue')

const details = () => import('./views/details.vue')

export default [
  {
    path: '/business/instructors',
    name: 'BusinessInstructors',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'BusinessInstructors',
      component: instructors,
      redirect: { name: 'instructors.current' },
      meta: { name: 'instructors', userType: 'provider', serviceTypes: 'all' },
      children: [
        {
          path: 'current',
          name: 'instructors.current',
          component: current,
          meta: { name: 'current', userType: 'provider', serviceTypes: 'all' }
        },
        {
          path: 'requests',
          name: 'instructors.requests',
          component: requests,
          meta: { name: 'requests', userType: 'provider', serviceTypes: 'all' }
        },
        {
          path: 'history',
          name: 'instructors.history',
          component: history,
          meta: { name: 'history', userType: 'provider', serviceTypes: 'all' }
        }
      ]
    },
    {
      path: 'instructor/:id',
      name: 'instructors.details',
      component: details,
      meta: { name: 'instructorDetails', userType: 'provider', serviceTypes: 'all' }
    }]
  }
]
